export const getCategoryDetailsLink = (categoryId: number) => {
    const isNewDesignModal = window.location.search.includes('create=true');

    return isNewDesignModal
        ? `/designs?create=true&page=category_details&categoryId=${categoryId}`
        : `/categories/${categoryId}`;
};
